// A window's participants must each be available for its entire duration.
// Additional people joining/leaving never break that group's continuous window.
function commonWindows(segments, minimum, required = []) {
  const candidates = [];
  for (let start = 0; start < segments.length; start++) {
    let common = segments[start].uids;
    if (common.length < minimum || !required.every(uid => common.includes(uid))) continue;
    for (let end = start + 1; end <= segments.length; end++) {
      const next = end < segments.length ? common.filter(uid => segments[end].uids.includes(uid)) : [];
      if (next.length !== common.length) {
        const fromMin = segments[start].fromMin, toMin = segments[end - 1].toMin;
        if (toMin - fromMin >= 60) candidates.push({fromMin, toMin, uids: common});
      }
      common = next;
      if (next.length < minimum || !required.every(uid => next.includes(uid))) break;
    }
  }
  // Keep the longest windows for each group, plus shorter windows with more people.
  return candidates.filter((window, index) => !candidates.some((other, otherIndex) =>
    otherIndex !== index && other.fromMin <= window.fromMin && other.toMin >= window.toMin &&
    window.uids.every(uid => other.uids.includes(uid)) &&
    (other.fromMin < window.fromMin || other.toMin > window.toMin || other.uids.length > window.uids.length || otherIndex < index)));
}

export function buildDailySummaries(availByMember, members, playerUids = []) {
  const roster = [...new Map(members.map(member => [member.uid, member])).values()];
  return Array.from({length: 7}, (_, day) => {
    const intervals = roster.map(member => {
      const rows = (availByMember[member.uid] || []).filter(row => row.day === day &&
        Number.isFinite(row.startMin) && Number.isFinite(row.endMin))
        .map(row => [Math.max(0, row.startMin), Math.min(1440, row.endMin)])
        .filter(([start, end]) => end > start).sort((a, b) => a[0] - b[0]);
      const merged = [];
      for (const [start, end] of rows) {
        const last = merged[merged.length - 1];
        if (last && start <= last[1]) last[1] = Math.max(last[1], end);
        else merged.push([start, end]);
      }
      return {uid: member.uid, rows: merged};
    });
    const boundaries = [...new Set(intervals.flatMap(member => member.rows.flat()))].sort((a, b) => a - b);
    const segments = boundaries.slice(0, -1).map((fromMin, index) => ({fromMin, toMin: boundaries[index + 1],
      uids: intervals.filter(member => member.rows.some(([start, end]) => start <= fromMin && end >= boundaries[index + 1])).map(member => member.uid)}));
    const overlaps = commonWindows(segments, 2).sort((a, b) => b.uids.length - a.uids.length || a.fromMin - b.fromMin || b.toMin - a.toMin);
    const players = playerUids.length ? commonWindows(segments, playerUids.length, playerUids)
      .sort((a, b) => a.fromMin - b.fromMin || b.toMin - a.toMin)
      .map(window => ({...window, extraUids: window.uids.filter(uid => !playerUids.includes(uid))})) : [];
    return {players, fivePlus: overlaps.filter(window => window.uids.length >= 5), overlaps};
  });
}

export function membersAvailableThroughout(byUid,members,day,fromMin,toMin) {
  return members.filter(({uid})=>{
    let covered=fromMin;
    for(const row of [...(byUid[uid]||[])].filter(row=>row.day===day).sort((a,b)=>a.startMin-b.startMin)){
      if(row.startMin>covered)break;
      if(row.endMin>covered)covered=row.endMin;
      if(covered>=toMin)return true;
    }
    return false;
  }).map(member=>member.uid);
}
